"use strict";
var appn;
(function (appn) {
    var popover;
    (function (popover_1) {
        popover_1.HINT_TEMPLATE = appn.popover.HINT_TEMPLATE;
        const POPOVER_TEMPLATE = '<div class="popover" role="tooltip"><div class="arrow"></div><button type="button" class="x close" data-dismiss="popover"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button><div class="popover-body"></div></div>';
        function init() {
            $('[data-widget="popover"]').popover({
                container: 'body',
                template: POPOVER_TEMPLATE
            });
            addEvents();
        }
        popover_1.init = init;
        function addEvents() {
            $('[data-widget="popover"]').off().on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                const $this = $(this);
                $('[data-widget="popover"]').not(this).popover('hide');
                $this.popover('toggle');
            });
            $('[data-dismiss="popover"]').off().on('click', function (e) {
                e.preventDefault();
                $(this).closest('.popover').popover('hide');
            });
            $('html').off().on('click', function (e) {
                const popover = $('.popover.show');
                if (!popover.is(e.target) && popover.has(e.target).length === 0)
                    appn.popover.dismissAll();
            });
        }
        function dismissAll() {
            $('[data-widget="popover"]').popover('hide');
        }
        popover_1.dismissAll = dismissAll;
        function hint(labelText, hintText, labelClasses, placement) {
            if (!hintText)
                return appn.emptyString;
            if (!labelClasses)
                labelClasses = appn.emptyString;
            if (!placement)
                placement = 'top';
            let hint = popover_1.HINT_TEMPLATE.replace('%labelText%', labelText)
                .replace('%hintText%', hintText)
                .replace('%labelClasses%', labelClasses)
                .replace('%placement%', placement);
            if (!labelText)
                hint = hint.replace('&nbsp;&nbsp;', appn.emptyString);
            return hint;
        }
        popover_1.hint = hint;
    })(popover = appn.popover || (appn.popover = {}));
})(appn || (appn = {}));
